import React, { createContext, useContext, useState, ReactNode } from 'react';
import { translations, Translations } from '../i18n/translations';

type Language = 'th' | 'en';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  // อ่านภาษาจาก localStorage หรือใช้ default เป็น 'th'
  const [language, setLanguageState] = useState<Language>(() => {
    const stored = localStorage.getItem('onionshack-language');
    return (stored === 'en' || stored === 'th') ? stored as Language : 'th';
  });

  // ฟังก์ชันสำหรับเปลี่ยนภาษาและบันทึกใน localStorage
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem('onionshack-language', lang);
  };

  const value = {
    language,
    setLanguage,
    t: translations[language],
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};